"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var Auth = __importStar(require("./auth"));

var firebase_1 = require("../../configs/firebase");

function _build(doc) {
  return Object.assign({}, {
    id: doc.id
  }, doc.data());
}

function getById(_x) {
  return _getById.apply(this, arguments);
}

function _getById() {
  _getById = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(userId) {
    var ref, item;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId).get();

          case 2:
            ref = _context.sent;

            if (!ref.exists) {
              _context.next = 8;
              break;
            }

            item = _build(ref);
            return _context.abrupt("return", item);

          case 8:
            return _context.abrupt("return", null);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getById.apply(this, arguments);
}

exports.getById = getById;

function create(_x2, _x3) {
  return _create.apply(this, arguments);
}

function _create() {
  _create = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(userId, props) {
    var docRef, info;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId).set({
              create_at: app_1.default.firestore.FieldValue.serverTimestamp(),
              device_locale: props.locale,
              device_locales: props.locales,
              device_country: props.country,
              device_timezone: props.timezone,
              device_isRTL: props.isRTL
            });

          case 2:
            docRef = _context2.sent;
            _context2.next = 5;
            return getById(userId);

          case 5:
            info = _context2.sent;

            if (info === null) {
              console.warn('Failed to get user info right after the creation');
            }

            return _context2.abrupt("return", info);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _create.apply(this, arguments);
}

exports.create = create;

function createIfEmpty(_x4) {
  return _createIfEmpty.apply(this, arguments);
}

function _createIfEmpty() {
  _createIfEmpty = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(props) {
    var userId, info;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context3.sent;
            _context3.next = 5;
            return getById(userId);

          case 5:
            info = _context3.sent;

            if (!(info === null)) {
              _context3.next = 12;
              break;
            }

            _context3.next = 9;
            return create(userId, props);

          case 9:
            return _context3.abrupt("return", _context3.sent);

          case 12:
            return _context3.abrupt("return", info);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _createIfEmpty.apply(this, arguments);
}

exports.createIfEmpty = createIfEmpty;

function updatePushNotiTokens(_x5, _x6) {
  return _updatePushNotiTokens.apply(this, arguments);
}

function _updatePushNotiTokens() {
  _updatePushNotiTokens = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(userId, tokenInfos) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId).update({
              push_tokens: tokenInfos
            });

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _updatePushNotiTokens.apply(this, arguments);
}

exports.updatePushNotiTokens = updatePushNotiTokens;

function getExtraInfoRef(userId) {
  return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId);
}

exports.getExtraInfoRef = getExtraInfoRef;

function updateExtraInfo(_x7, _x8) {
  return _updateExtraInfo.apply(this, arguments);
}

function _updateExtraInfo() {
  _updateExtraInfo = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5(userId, props) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId).update(props);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateExtraInfo.apply(this, arguments);
}

exports.updateExtraInfo = updateExtraInfo;

function resetNewReviewingItemsCounter() {
  return _resetNewReviewingItemsCounter.apply(this, arguments);
}

function _resetNewReviewingItemsCounter() {
  _resetNewReviewingItemsCounter = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var userId;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context6.sent;
            _context6.next = 5;
            return updateExtraInfo(userId, {
              count_new_reviewing_items: 0
            });

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _resetNewReviewingItemsCounter.apply(this, arguments);
}

exports.resetNewReviewingItemsCounter = resetNewReviewingItemsCounter;

function resetNewIdleItemsCounter() {
  return _resetNewIdleItemsCounter.apply(this, arguments);
}

function _resetNewIdleItemsCounter() {
  _resetNewIdleItemsCounter = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var userId;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context7.sent;
            _context7.next = 5;
            return updateExtraInfo(userId, {
              count_new_idle_items: 0
            });

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _resetNewIdleItemsCounter.apply(this, arguments);
}

exports.resetNewIdleItemsCounter = resetNewIdleItemsCounter;

function changeNickname(_x9) {
  return _changeNickname.apply(this, arguments);
}

function _changeNickname() {
  _changeNickname = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8(nickname) {
    var userId;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Auth.getUserId();

          case 2:
            userId = _context8.sent;
            _context8.next = 5;
            return app_1.default.firestore().collection(firebase_1.CN_USERS).doc(userId).update({
              nickname: nickname
            });

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _changeNickname.apply(this, arguments);
}

exports.changeNickname = changeNickname;